import { RouteObject } from 'react-router';

import { RequireAuthentication } from 'containers/RequireAuthentication';
import { AdminsLinksLoadable } from 'modules/orgDashboard/pages/admins/links/AdminsLinksLoadable';
import { BuyCreditsLinksLoadable } from 'modules/orgDashboard/pages/credits/buyLinks/BuyCreditsLinksLoadable';
import { CreditsLinksLoadable } from 'modules/orgDashboard/pages/credits/links/CreditsLinksLoadable';
import { GradFairsLinksLoadable } from 'modules/orgDashboard/pages/gradFairs/links/GradFairsLinksLoadable';
import { IntegrateAtsLinksLoadable } from 'modules/orgDashboard/pages/integrations/atsLinks/IntegrateAtsLinksLoadable';
import { InvoicesLinksLoadable } from 'modules/orgDashboard/pages/invoices/links/InvoicesLinksLoadable';
import { EditOrgLinksLoadable } from 'modules/orgDashboard/pages/orgs/editLinks/EditOrgLinksLoadable';
import { loadableLoader } from 'routing/utils/loadableLoader';

/**
 * A set of routes that use OrgDashboardOrgSelectionSubLayout
 *
 * These routes are separate in their own file to facilitate maintenance, and
 * they're used on `main.route-objects.tsx`
 */
export const orgSelectRouteObjects = [
  {
    path: '/buy-credits',
    loader: loadableLoader(BuyCreditsLinksLoadable),
    element: (
      <RequireAuthentication>
        <BuyCreditsLinksLoadable />
      </RequireAuthentication>
    ),
  },
  {
    path: '/integrate-ats',
    loader: loadableLoader(IntegrateAtsLinksLoadable),
    element: (
      <RequireAuthentication>
        <IntegrateAtsLinksLoadable />
      </RequireAuthentication>
    ),
  },
  {
    path: '/credits',
    loader: loadableLoader(CreditsLinksLoadable),
    element: (
      <RequireAuthentication>
        <CreditsLinksLoadable />
      </RequireAuthentication>
    ),
  },
  {
    path: '/admins',
    loader: loadableLoader(AdminsLinksLoadable),
    element: (
      <RequireAuthentication>
        <AdminsLinksLoadable />
      </RequireAuthentication>
    ),
  },
  {
    path: '/edit-org',
    loader: loadableLoader(EditOrgLinksLoadable),
    element: (
      <RequireAuthentication>
        <EditOrgLinksLoadable />
      </RequireAuthentication>
    ),
  },
  {
    path: '/gradfairs',
    loader: loadableLoader(GradFairsLinksLoadable),
    element: (
      <RequireAuthentication>
        <GradFairsLinksLoadable />
      </RequireAuthentication>
    ),
  },
  {
    path: '/invoices',
    loader: loadableLoader(InvoicesLinksLoadable),
    element: (
      <RequireAuthentication>
        <InvoicesLinksLoadable />
      </RequireAuthentication>
    ),
  },
] satisfies RouteObject[];
